import React from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import Card from '../../layout/Card';
import ModuleHome from '../../layout/ModuleHome';
import { breadcrumbsPropTypes } from '../../common/resource/proptypes/CommonPropTypes';

export const LocationHome = ({ cards, breadcrumbs }) => (
  <ModuleHome
    title="Gestión de Ubicaciones"
    text="Éste es el módulo de gestión de ubicaciones."
    cards={cards}
    breadcrumbs={breadcrumbs}
  />
);

const mapStateToProps = (state) => ({
  cards: state.LocationUnit.UnitHome.get('cards'),
  breadcrumbs: state.LocationUnit.UnitHome.get('breadcrumbs'),
});

LocationHome.propTypes = {
  breadcrumbs: breadcrumbsPropTypes.isRequired,
  cards: PropTypes.arrayOf(PropTypes.shape(Card.propTypes)).isRequired,
};

export default connect(mapStateToProps)(LocationHome);
